import { Button } from 'react-bootstrap';
import { getDateOrdinal } from 'utils/dateUtils';
import { DailyOccurrence } from '../DailyOccurrence';

export const MonthlyOccurrence = ({
  events = [],
  showEmptyDays = false,
  source = '',
  onDrillDown,
  showAssigner = false,
}) => {
  const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  // Sort events by date first
  const sortedEvents = [...events].sort((a, b) => a.start - b.start);

  // Group by full date (YYYY-MM-DD) so events in different months are never merged.
  const byDate = {};
  sortedEvents.forEach((event) => {
    const d = event.start;
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    if (!byDate[key]) byDate[key] = [];
    byDate[key].push(event);
  });

  // Keys are already chronological because we sorted events first and ISO strings sort correctly.
  const sortedKeys = Object.keys(byDate);

  const keyLabel = (key) => {
    const [, monthStr, dayStr] = key.split('-');
    return `${MONTH_NAMES[parseInt(monthStr, 10) - 1]} ${getDateOrdinal(parseInt(dayStr, 10))}`;
  };

  return (
    <div className="d-flex flex-row flex-wrap gap-3">
      {sortedKeys.map((key) => (
        <div
          key={key}
          style={{
            minWidth: '250px',
            maxWidth: '250px',
            flex: '1 0 20%',
            boxSizing: 'border-box',
          }}
        >
          <h4 className="text-center">{keyLabel(key)}</h4>
          <div style={{ minWidth: '20%', flex: '1 0 20%', boxSizing: 'border-box' }}>
            {byDate[key].length > 1 && onDrillDown ? (
              <Button
                variant="outline-light"
                size="sm"
                className="w-100 mt-1"
                onClick={() => onDrillDown(byDate[key], keyLabel(key))}
              >
                {byDate[key].length} occurrences — View Day
              </Button>
            ) : (
              <DailyOccurrence
                events={byDate[key] || []}
                source={source}
                showAssigner={showAssigner}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
